module.exports = __webpack_public_path__ + "img/door.266f1bc7.png";